export default "__VITE_ASSET__Dh1C8zJL__";